import { AuthService } from './authService';
import { PickRuleDto } from '../types/pickRule';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class PickRuleService {
  private baseUrl = `${API_BASE_URL}/pick-rules`;

  async getAll(): Promise<PickRuleDto[]> {
    const response = await AuthService.authenticatedGet(`${this.baseUrl}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  }

  async getByPickRuleNo(pickRuleNo: number): Promise<PickRuleDto | null> {
    try {
      const response = await AuthService.authenticatedGet(`${this.baseUrl}/${pickRuleNo}`);
      if (!response.ok) {
        if (response.status === 404) {
          return null;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error: any) {
      if (error.message?.includes('404')) {
        return null;
      }
      throw error;
    }
  }
}

export const pickRuleService = new PickRuleService();
